import React from 'react';
import theme from './SmallAttachmentList.module.scss';
import { AttachmentLike } from '@/components/AttachmentList';
import { classnames } from '@/utils/html';
import { FileIcon } from '@ygtechnologies/bygr-frontend-component-library';

interface SmallAttachmentListProps {
    attachments: AttachmentLike[];
    urlGenerator(att: AttachmentLike): string;
    className?: string;
}

const SmallAttachmentList: React.FC<SmallAttachmentListProps> = ({ attachments, urlGenerator, className }) => {
    if (!attachments || attachments.length === 0) {
        return null;
    }

    return (
        <ul className={classnames(theme.attachmentsList, className)}>
            {attachments.map((att) => (
                <li key={att.id}>
                    <a href={urlGenerator(att)} target="_blank" rel="noreferrer noopener">
                        <FileIcon size="lg" value={att.fileMetadata} className={theme.fileIcon} hideExtensions fixedWidth />
                        {att.name}
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default SmallAttachmentList;
